import { render, staticRenderFns } from "./Lgx02660548448372964458734.vue?vue&type=template&id=4f48cc9f&"
import script from "./Lgx02660548448372964458734.vue?vue&type=script&lang=js&"
export * from "./Lgx02660548448372964458734.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports